import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import config from "../../../app-config";
import { useUser } from "../../hooks/useUser";

export const cioanalytics = AnalyticsBrowser.load(
  {
    writeKey: config.customerIoWriteKey,
    cdnURL: "https://cdp-eu.customer.io",
  },
  {
    integrations: {
      "Customer.io In-App Plugin": {
        siteId: config.customerIoSiteId,
      },
    },
  },
);

export function CustomerIo() {
  const user  = useUser();
  const location = useLocation();

  useEffect(() => {
    if (user?.id) {
      cioanalytics.identify(user.id);
    }
  }, [user?.id]);

  useEffect(() => {
    cioanalytics.page();
  }, [location.pathname]);

  return null;
}
